import { render, staticRenderFns } from "./DataStatistics.vue?vue&type=template&id=49a5447c&scoped=true&"
import script from "./DataStatistics.vue?vue&type=script&lang=js&"
export * from "./DataStatistics.vue?vue&type=script&lang=js&"
import style0 from "styles/views/orderAdmin/dataStatistics.css?vue&type=style&index=0&id=49a5447c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a5447c",
  null
  
)

export default component.exports